import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueKeybindings from 'vue-keybindings'
import i18n from './i18n'
import vSelect from 'vue-select'
import VueGtag from "vue-gtag";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-select/dist/vue-select.css';
import VDragged from 'v-dragged'
import ProductFruits from '@/utils/onboarding/ProductFruits.js'
import browserDetect from "vue-browser-detect-plugin";
import VueMixpanel from 'vue-mixpanel'
import mixpanel from '@/mixins/Mixpanel.js'
import VueConfetti from 'vue-confetti'
import DoubleTap from '@/plugins/doubleTap'
import pro from '@/utils/proDirective.js'

import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import 'ag-grid-enterprise';

import { LicenseManager } from "@ag-grid-enterprise/core";

LicenseManager.setLicenseKey("your license key");

import {
  // Directives
  VTooltip
} from 'floating-vue'
import VueKonva from 'vue-konva';

Vue.use(VueConfetti)
Vue.use(VueKonva);
Vue.use(browserDetect);
Vue.directive('tooltip', VTooltip)
Vue.component('ProductFruits', ProductFruits)
Vue.use(VDragged)

Vue.use(VueMixpanel, {
  token: '5019c6050fb142361c60b8dbfb9842c7',
  config: {
    debug: false
  }
})

var nofocus = Vue.directive('no-focus', {
  inserted: (el) => {
    const select = el.querySelector('.v-input__slot');
    if (select) {
      select.addEventListener('change', () => el.querySelector('input')?.blur());
      select.addEventListener('click', () => el.querySelector('input')?.blur());
    }
  },
  bind: function(el) {
    el.addEventListener('focus', () => {
      el.blur()
    });
  }
})

const nospace = Vue.directive('prevent-space-scroll', {
  inserted(el) {
    // Make sure the element is focusable
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    el._onKeyDown = function(event) {
      if (event.code === 'Space') {
        event.preventDefault();
      }
    };

    el.addEventListener('keydown', el._onKeyDown);
  },
  unbind(el) {
    el.removeEventListener('keydown', el._onKeyDown);
    delete el._onKeyDown;
  }
});

Vue.use(DoubleTap)

Vue.config.productionTip = false

Vue.use(nofocus)
Vue.use(nospace)
Vue.use(pro)
Vue.use(VueKeybindings, {
    alias: {
        toggle: ['space'],

        skipForwardLarge: 'shift+arrowright',
        skipForward: ['arrowright'],
        skipForwardSmall: 'alt+arrowright',

        skipBackwardLarge: 'shift+arrowleft',
        skipBackward: ['arrowleft'],
        skipBackwardSmall: 'alt+arrowleft',

        escape: 'esc',

        shift: 'shift',
        n: 'n',
        shift_n: 'shift+n',
        m: 'm',
        shift_m: 'shift+m',
        q: 'q',
        shift_q: 'shift+q',
        // O
        8: '8',
        i: 'i',
        k: 'k',
        hyphen: ',',
        // X
        9: '9',
        o: 'o',
        l: 'l',
        dot: '.',
        // H
        0: '0',
        p: 'p',
        ö: 'ö',
        line: '-',
        dash: '-',
        1: '1',
        2: '2',
        3: '3',
        shift_1: 'shift+!',
        shift_2: 'shift+"',
        shift_3: 'shift+#',
        shift_4: 'shift+€',
        shift_5: 'shift+%',
        shift_6: 'shift+&',
        shift_7: 'shift+/',
        shift_8: 'shift+(',
        shift_9: 'shift+)',
        shift_0: 'shift+=',

        // Other
        a: 'a',
        c: 'c',
        f: 'f',
        e: 'e',
        shift_e: 'shift+e',
        y: 'y',
        u: 'u',
        x: 'x',
        z: 'z',
        j: 'j',
        h: 'h',
        s: 's',
        shift_j: 'shift+j',
        shift_x: 'shift+x',
        shift_z: 'shift+z',
        ctrl_x: 'ctrl+x',
        ctrl_z: 'ctrl+z',
        shift_f: 'shift+f',
        b: 'b',
        shift_b: 'shift+b',
        shift_l: 'shift+l',
        shift_s: 'shift+s',
        shift_g: 'shift+g',
        shift_v: 'shift+v',
        shift_ä: 'shift+ä',
        ä: 'ä',
        shift_up: 'shift+arrowup',
        shift_down: 'shift+arrowdown',
        esc: 'esc',
        shift_ctrl_up: 'shift+ctrl+arrowup',
        shift_ctrl_down: 'shift+ctrl+arrowdown',
        shift_ctrl_b: 'shift+ctrl+b',
        shift_r: 'shift+r',
        shift_d: 'shift+d',
        shift_h: 'shift+h',

        shift_i: 'shift+i',

        rateDown: 'shift+arrowdown',
        rateUp: 'shift+arrowup',

        enter: ['enter'],

        w: ['w'],
        d: ['d'],
        t: ['t'],
        down: 'arrowdown',
        up: 'arrowup',

        v: 'v',
    }
})

var prevent_keys = Vue.directive('prevent-keys', {
  bind: function(el) {
    el.addEventListener('focusin', () => {
      store.commit('DISABLE_KEYBINDS')
    });

    el.addEventListener('focusout', () => {
      store.commit('ENABLE_KEYBINDS')
    });
  }
})

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.use(prevent_keys)
Vue.component('vue-select', vSelect)

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "G-LK8Q1JL75S" }
}, router);

Vue.mixin(mixpanel)

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')